export default store => next => action => {
    if (console.group) {
        console.groupCollapsed(action.type);
        console.log("%c prev state", "color: gray", store.getState());
        console.log("%c dispatching", "color: blue", action);
        let result = next(action);
        console.log("%c next state", "color: green", store.getState());
        console.groupEnd(action.type);
        return result;
    }
    return next(action);
};
